{{#each allConstraints}}
constraint {{ name }} {
{{#eachLine content}}
  {{.}}
{{/eachLine}}
}

{{/each}}
